import {getUsers} from "../../api/users";

const state = () => ({

  user:{},
  usersId: 0
})

const getters = {
  get_user(state) {
    return state.user;
  },
}

const mutations = {
  SET_USER(state,data){
    state.user = data;}
}

const actions = {
  async fetchUser({ commit },payload) {
    try {
      const response = await getUsers(payload.page,payload.pagesSize);
      commit('SET_USER', response.data);
    } catch (error) {
      // handle the error here
    }
  },

}




export  default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
